import React, {useEffect} from 'react';
import Cookies from 'js-cookie'
import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import HistoryPage from "pages/history/HistoryPage";

import QuotesPage from "pages/quotes";
import SettingsPage from "./pages/settings/SettingsPage";
import RequireAuth from "./hoc/RequireAuth";
import AuthPage from "./pages/auth/AuthPage";


export const logout = async () => {
    Cookies.remove('access')
}

const pages = [
    {
        path: '',
        element: <Navigate to="/quotes" />
    },
    {
        path: 'quotes',
        element: <QuotesPage/>
    },
    {
        path: 'settings',
        element: <SettingsPage/>
    },
    {
        path: 'calculations',
        element: <HistoryPage/>
    }
]

const Main = () => {
    return (
        <Routes>
            {pages.map(({path, element}) =>
                <Route index={path === 'quotes'} key={path} path={path} element={
                    <RequireAuth>
                        {element}
                    </RequireAuth>
                }/>
            )}
            <Route path="login" element={<AuthPage/>}/>
        </Routes>
    )
};

export default Main;
